import React from 'react';
import { useTranslation } from 'react-i18next';
import { Layout, Typography } from 'antd';
import styled from '@emotion/styled';
import { CardUpload, CardNotice, CardCreatorGuide } from '@components/HomeCards';
import useStores from '@lib/hooks/useStores';
import { IUserStore } from '@stores/userStore';
import Title from 'antd/lib/typography/Title';
const { Content } = Layout;

const Home: React.FC = () => {
  const { t } = useTranslation();
  const { userStore } = useStores<{ userStore: IUserStore }>();

  return (
    <ContentBlock>
      <Typography>
        <Title level={2}>{t('home.title')}</Title>
      </Typography>
      <CardBlock>
        <CardColumn>
          {userStore.isVerifiedCreator && <CardUpload />}
          {/* <CardContestPromotion /> */}
          <CardNotice />
        </CardColumn>
        <CardColumn>
          <CardCreatorGuide />
        </CardColumn>
      </CardBlock>
    </ContentBlock>
  );
};

const ContentBlock = styled(Content)`
  padding: 19px 36px;
`;

const CardBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  padding-bottom: 32px;

  .card-item + .card-item {
    margin-top: 32px;
  }
`;

const CardColumn = styled.div`
  /* & + & {
    margin-left: 30px;
  } */
`;

export default Home;
